import { useEffect } from "react";
import { history } from "./history";

export const UseRedirectToNr = () => {
  useEffect(() => {
    console.log("render");
    console.log("history", history.location.pathname);
    const routesWithoutNr = [
      "/login/error_report/",
      "/login/fmea/",
      "/login/checklist/",
    ];
    const matchedRoute = routesWithoutNr.find((route) =>
      history.location.pathname.startsWith(route)
    );
    if (matchedRoute) {
      const newPath = `/nr${history.location.pathname}`;
      const queryParams = history.location.search;
      window.location.href = `https://app.snjob.ir${newPath}${queryParams}`;
    }
  }, [history.location.pathname]);

  return null;
};
